"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventListenerManager_1 = require("../../DOM/EventTarget/EventListenerManager");
(() => {
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
    EventTarget.prototype.removeEventListener = function removeEventListener(type, callback, options) {
        const types = type.split(/\s+/);
        const listeners = EventListenerManager_1.default.getListeners(this);
        Array.from(listeners).forEach((entry) => {
            if (entry.listener === callback && (types.includes(entry.type) || types.includes(entry.eventName))) {
                listeners.splice(listeners.indexOf(entry), 1);
                originalRemoveEventListener.apply(this, [entry.eventName, callback, options]);
            }
        });
    };
    EventTarget.prototype.removeEventListeners = function removeEventListeners(targetTypes) {
        const listeners = EventListenerManager_1.default.getListeners(this);
        const types = (targetTypes !== null && targetTypes !== void 0 ? targetTypes : '*').split(/\s+/);
        Array.from(listeners).forEach((entry) => {
            if (types.includes('*') || types.includes(entry.type) || types.includes(entry.eventName)) {
                originalRemoveEventListener.apply(this, [entry.eventName, entry.listener]);
                listeners.splice(listeners.indexOf(entry), 1);
            }
        });
    };
})();
//# sourceMappingURL=RemoveEventListeners.js.map